import React from "react";
import {Image} from "primereact/image";

export default function Child(params) {
    if (params.model.fio) {
        return (
            <div className="d-flex align-items-center">
                <Image preview imageClassName={'img-40 rounded-circle'} className={'m-r-10 rounded-circle overflow-hidden'}
                     src={"http://yii2.easytickets.pro" + params.model.avatar} alt=""/>
                <span>{params.model.fio}<br/>{params.model.birthday_text}</span>
            </div>

        )
    } else {
        return <></>
    }
}